import React from 'react';

const ErrorState = ({ error, onRetry }) => (
  <div className="error-state">
    <span className="error-icon">⚠️</span>
    <p>Ошибка загрузки: {error}</p>
    <button onClick={onRetry} className="btn-primary">
      Повторить попытку
    </button>
  </div>
);

export default ErrorState;